import { defineMessages } from 'react-intl'

const scope = `modules.purchasing.features.createPODisclaimerLabel.presenters.createPODisclaimerLabelFormPresenter`

export default defineMessages({
  successTitle: {
    id: `${scope}.successTitle`,
    defaultMessage: 'Success',
  },
  errorTitle: {
    id: `${scope}.errorTitle`,
    defaultMessage: 'Error',
  },
  successMessage: {
    id: `${scope}.successMessage`,
    defaultMessage: 'Label item has been created.',
  },
  duplicateDescriptionError: {
    id: `${scope}.duplicateDescriptionError`,
    defaultMessage: 'Purchase order labels should be unique.',
  },
  defaultErrorMessage: {
    id: `${scope}.defaultErrorMessage`,
    defaultMessage: 'Failed to create the label.',
  },
})
